import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class MethodMetadata {
  static fromProto(proto) {
    let m = new MethodMetadata();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.isPublic !== 'undefined') {
      toReturn['isPublic'] = this.isPublic;
    }
    if (typeof this.scopes !== 'undefined') {
      toReturn['scopes'] = this.scopes;
    }
    return toReturn;
  }
}
class SDKMetadata {
  static fromProto(proto) {
    let m = new SDKMetadata();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sdkName !== 'undefined') {
      toReturn['sdkName'] = this.sdkName;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var Alignment = /*#__PURE__*/function (Alignment) {
  Alignment[Alignment["ALIGNMENT_RELAXED"] = 0] = "ALIGNMENT_RELAXED";
  Alignment[Alignment["ALIGNMENT_STRICT"] = 1] = "ALIGNMENT_STRICT";
  return Alignment;
}(Alignment || {});
var DMARCPolicy = /*#__PURE__*/function (DMARCPolicy) {
  DMARCPolicy[DMARCPolicy["DMARC_POLICY_NONE"] = 0] = "DMARC_POLICY_NONE";
  DMARCPolicy[DMARCPolicy["DMARC_POLICY_QUARANTINE"] = 1] = "DMARC_POLICY_QUARANTINE";
  DMARCPolicy[DMARCPolicy["DMARC_POLICY_REJECT"] = 2] = "DMARC_POLICY_REJECT";
  return DMARCPolicy;
}(DMARCPolicy || {});
var ReportOption = /*#__PURE__*/function (ReportOption) {
  ReportOption[ReportOption["REPORT_OPTION_ALL_FAILED"] = 0] = "REPORT_OPTION_ALL_FAILED";
  ReportOption[ReportOption["REPORT_OPTION_ANY_FAILED"] = 1] = "REPORT_OPTION_ANY_FAILED";
  ReportOption[ReportOption["REPORT_OPTION_DKIM_FAILED"] = 2] = "REPORT_OPTION_DKIM_FAILED";
  ReportOption[ReportOption["REPORT_OPTION_SPF_FAILED"] = 3] = "REPORT_OPTION_SPF_FAILED";
  return ReportOption;
}(ReportOption || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var DNSRecordType = /*#__PURE__*/function (DNSRecordType) {
  DNSRecordType[DNSRecordType["A_RECORD"] = 0] = "A_RECORD";
  DNSRecordType[DNSRecordType["CNAME_RECORD"] = 1] = "CNAME_RECORD";
  DNSRecordType[DNSRecordType["CAA_RECORD"] = 2] = "CAA_RECORD";
  DNSRecordType[DNSRecordType["TXT_RECORD"] = 3] = "TXT_RECORD";
  DNSRecordType[DNSRecordType["AAAA_RECORD"] = 4] = "AAAA_RECORD";
  return DNSRecordType;
}(DNSRecordType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var MechanismType = /*#__PURE__*/function (MechanismType) {
  MechanismType[MechanismType["MECHANISM_TYPE_ALL"] = 0] = "MECHANISM_TYPE_ALL";
  MechanismType[MechanismType["MECHANISM_TYPE_INCLUDE"] = 1] = "MECHANISM_TYPE_INCLUDE";
  MechanismType[MechanismType["MECHANISM_TYPE_A"] = 2] = "MECHANISM_TYPE_A";
  MechanismType[MechanismType["MECHANISM_TYPE_MX"] = 3] = "MECHANISM_TYPE_MX";
  MechanismType[MechanismType["MECHANISM_TYPE_PTR"] = 4] = "MECHANISM_TYPE_PTR";
  MechanismType[MechanismType["MECHANISM_TYPE_IP4"] = 5] = "MECHANISM_TYPE_IP4";
  MechanismType[MechanismType["MECHANISM_TYPE_IP6"] = 6] = "MECHANISM_TYPE_IP6";
  MechanismType[MechanismType["MECHANISM_TYPE_EXISTS"] = 7] = "MECHANISM_TYPE_EXISTS";
  return MechanismType;
}(MechanismType || {});
var Qualifier = /*#__PURE__*/function (Qualifier) {
  Qualifier[Qualifier["QUALIFIER_PASS"] = 0] = "QUALIFIER_PASS";
  Qualifier[Qualifier["QUALIFIER_FAIL"] = 1] = "QUALIFIER_FAIL";
  Qualifier[Qualifier["QUALIFIER_SOFT_FAIL"] = 2] = "QUALIFIER_SOFT_FAIL";
  Qualifier[Qualifier["QUALIFIER_NEUTRAL"] = 3] = "QUALIFIER_NEUTRAL";
  return Qualifier;
}(Qualifier || {});
// *********************************

function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class DMARCRecord {
  static fromProto(proto) {
    let m = new DMARCRecord();
    m = Object.assign(m, proto);
    if (proto.domainPolicy) {
      m.domainPolicy = enumStringToValue$4(DMARCPolicy, proto.domainPolicy);
    }
    if (proto.subdomainPolicy) {
      m.subdomainPolicy = enumStringToValue$4(DMARCPolicy, proto.subdomainPolicy);
    }
    if (proto.dkimAlignment) {
      m.dkimAlignment = enumStringToValue$4(Alignment, proto.dkimAlignment);
    }
    if (proto.spfAlignment) {
      m.spfAlignment = enumStringToValue$4(Alignment, proto.spfAlignment);
    }
    if (proto.reportOption) {
      m.reportOption = enumStringToValue$4(ReportOption, proto.reportOption);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.reportAggregate !== 'undefined') {
      toReturn['reportAggregate'] = this.reportAggregate;
    }
    if (typeof this.reportForensics !== 'undefined') {
      toReturn['reportForensics'] = this.reportForensics;
    }
    if (typeof this.filterPercent !== 'undefined') {
      toReturn['filterPercent'] = this.filterPercent;
    }
    if (typeof this.domainPolicy !== 'undefined') {
      toReturn['domainPolicy'] = this.domainPolicy;
    }
    if (typeof this.subdomainPolicy !== 'undefined') {
      toReturn['subdomainPolicy'] = this.subdomainPolicy;
    }
    if (typeof this.dkimAlignment !== 'undefined') {
      toReturn['dkimAlignment'] = this.dkimAlignment;
    }
    if (typeof this.spfAlignment !== 'undefined') {
      toReturn['spfAlignment'] = this.spfAlignment;
    }
    if (typeof this.reportOption !== 'undefined') {
      toReturn['reportOption'] = this.reportOption;
    }
    if (typeof this.raw !== 'undefined') {
      toReturn['raw'] = this.raw;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AAAARecord {
  static fromProto(proto) {
    let m = new AAAARecord();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class ARecord {
  static fromProto(proto) {
    let m = new ARecord();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class CAARecord {
  static fromProto(proto) {
    let m = new CAARecord();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = proto.value.map(CAAValue.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class CAAValue {
  static fromProto(proto) {
    let m = new CAAValue();
    m = Object.assign(m, proto);
    if (proto.ttl) {
      m.ttl = parseInt(proto.ttl, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    if (typeof this.issuerCriticalFlag !== 'undefined') {
      toReturn['issuerCriticalFlag'] = this.issuerCriticalFlag;
    }
    if (typeof this.tag !== 'undefined') {
      toReturn['tag'] = this.tag;
    }
    if (typeof this.ttl !== 'undefined') {
      toReturn['ttl'] = this.ttl;
    }
    if (typeof this.recordClass !== 'undefined') {
      toReturn['recordClass'] = this.recordClass;
    }
    return toReturn;
  }
}
class CNameRecord {
  static fromProto(proto) {
    let m = new CNameRecord();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class TXTRecord {
  static fromProto(proto) {
    let m = new TXTRecord();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Directive {
  static fromProto(proto) {
    let m = new Directive();
    m = Object.assign(m, proto);
    if (proto.qualifier) {
      m.qualifier = enumStringToValue$2(Qualifier, proto.qualifier);
    }
    if (proto.type) {
      m.type = enumStringToValue$2(MechanismType, proto.type);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.qualifier !== 'undefined') {
      toReturn['qualifier'] = this.qualifier;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class Modifier {
  static fromProto(proto) {
    let m = new Modifier();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tag !== 'undefined') {
      toReturn['tag'] = this.tag;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class SPFRecord {
  static fromProto(proto) {
    let m = new SPFRecord();
    m = Object.assign(m, proto);
    if (proto.directives) {
      m.directives = proto.directives.map(Directive.fromProto);
    }
    if (proto.modifiers) {
      m.modifiers = proto.modifiers.map(Modifier.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.directives !== 'undefined' && this.directives !== null) {
      toReturn['directives'] = 'toApiJson' in this.directives ? this.directives.toApiJson() : this.directives;
    }
    if (typeof this.modifiers !== 'undefined' && this.modifiers !== null) {
      toReturn['modifiers'] = 'toApiJson' in this.modifiers ? this.modifiers.toApiJson() : this.modifiers;
    }
    if (typeof this.raw !== 'undefined') {
      toReturn['raw'] = this.raw;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Domain {
  static fromProto(proto) {
    let m = new Domain();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    if (typeof this.secure !== 'undefined') {
      toReturn['secure'] = this.secure;
    }
    return toReturn;
  }
}
class GetDMARCRecordRequest {
  static fromProto(proto) {
    let m = new GetDMARCRecordRequest();
    m = Object.assign(m, proto);
    if (proto.primary) {
      m.primary = Domain.fromProto(proto.primary);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.primary !== 'undefined' && this.primary !== null) {
      toReturn['primary'] = 'toApiJson' in this.primary ? this.primary.toApiJson() : this.primary;
    }
    return toReturn;
  }
}
class GetDMARCRecordResponse {
  static fromProto(proto) {
    let m = new GetDMARCRecordResponse();
    m = Object.assign(m, proto);
    if (proto.record) {
      m.record = DMARCRecord.fromProto(proto.record);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.record !== 'undefined' && this.record !== null) {
      toReturn['record'] = 'toApiJson' in this.record ? this.record.toApiJson() : this.record;
    }
    return toReturn;
  }
}
class GetDNSRecordsRequest {
  static fromProto(proto) {
    let m = new GetDNSRecordsRequest();
    m = Object.assign(m, proto);
    if (proto.recordTypes) {
      m.recordTypes = proto.recordTypes.map(v => enumStringToValue(DNSRecordType, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    if (typeof this.recordTypes !== 'undefined') {
      toReturn['recordTypes'] = this.recordTypes;
    }
    return toReturn;
  }
}
class GetDNSRecordsResponse {
  static fromProto(proto) {
    let m = new GetDNSRecordsResponse();
    m = Object.assign(m, proto);
    if (proto.aRecord) {
      m.aRecord = ARecord.fromProto(proto.aRecord);
    }
    if (proto.cnameRecord) {
      m.cnameRecord = CNameRecord.fromProto(proto.cnameRecord);
    }
    if (proto.caaRecord) {
      m.caaRecord = CAARecord.fromProto(proto.caaRecord);
    }
    if (proto.aaaaRecord) {
      m.aaaaRecord = AAAARecord.fromProto(proto.aaaaRecord);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    if (typeof this.aRecord !== 'undefined' && this.aRecord !== null) {
      toReturn['aRecord'] = 'toApiJson' in this.aRecord ? this.aRecord.toApiJson() : this.aRecord;
    }
    if (typeof this.cnameRecord !== 'undefined' && this.cnameRecord !== null) {
      toReturn['cnameRecord'] = 'toApiJson' in this.cnameRecord ? this.cnameRecord.toApiJson() : this.cnameRecord;
    }
    if (typeof this.caaRecord !== 'undefined' && this.caaRecord !== null) {
      toReturn['caaRecord'] = 'toApiJson' in this.caaRecord ? this.caaRecord.toApiJson() : this.caaRecord;
    }
    if (typeof this.aaaaRecord !== 'undefined' && this.aaaaRecord !== null) {
      toReturn['aaaaRecord'] = 'toApiJson' in this.aaaaRecord ? this.aaaaRecord.toApiJson() : this.aaaaRecord;
    }
    return toReturn;
  }
}
class GetDomainByIdentifierRequest {
  static fromProto(proto) {
    let m = new GetDomainByIdentifierRequest();
    m = Object.assign(m, proto);
    if (proto.identifier) {
      m.identifier = Identifier.fromProto(proto.identifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identifier !== 'undefined' && this.identifier !== null) {
      toReturn['identifier'] = 'toApiJson' in this.identifier ? this.identifier.toApiJson() : this.identifier;
    }
    return toReturn;
  }
}
class GetDomainByIdentifierResponse {
  static fromProto(proto) {
    let m = new GetDomainByIdentifierResponse();
    m = Object.assign(m, proto);
    if (proto.primary) {
      m.primary = Domain.fromProto(proto.primary);
    }
    if (proto.secondaries) {
      m.secondaries = proto.secondaries.map(Domain.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.primary !== 'undefined' && this.primary !== null) {
      toReturn['primary'] = 'toApiJson' in this.primary ? this.primary.toApiJson() : this.primary;
    }
    if (typeof this.secondaries !== 'undefined' && this.secondaries !== null) {
      toReturn['secondaries'] = 'toApiJson' in this.secondaries ? this.secondaries.toApiJson() : this.secondaries;
    }
    return toReturn;
  }
}
class GetIdentifierByDomainRequest {
  static fromProto(proto) {
    let m = new GetIdentifierByDomainRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    return toReturn;
  }
}
class GetIdentifierByDomainResponse {
  static fromProto(proto) {
    let m = new GetIdentifierByDomainResponse();
    m = Object.assign(m, proto);
    if (proto.identifier) {
      m.identifier = Identifier.fromProto(proto.identifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identifier !== 'undefined' && this.identifier !== null) {
      toReturn['identifier'] = 'toApiJson' in this.identifier ? this.identifier.toApiJson() : this.identifier;
    }
    return toReturn;
  }
}
class GetSPFRecordRequest {
  static fromProto(proto) {
    let m = new GetSPFRecordRequest();
    m = Object.assign(m, proto);
    if (proto.primary) {
      m.primary = Domain.fromProto(proto.primary);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.primary !== 'undefined' && this.primary !== null) {
      toReturn['primary'] = 'toApiJson' in this.primary ? this.primary.toApiJson() : this.primary;
    }
    return toReturn;
  }
}
class GetSPFRecordResponse {
  static fromProto(proto) {
    let m = new GetSPFRecordResponse();
    m = Object.assign(m, proto);
    if (proto.record) {
      m.record = SPFRecord.fromProto(proto.record);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.record !== 'undefined' && this.record !== null) {
      toReturn['record'] = 'toApiJson' in this.record ? this.record.toApiJson() : this.record;
    }
    return toReturn;
  }
}
class Identifier {
  static fromProto(proto) {
    let m = new Identifier();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contextualIdentifier !== 'undefined') {
      toReturn['contextualIdentifier'] = this.contextualIdentifier;
    }
    return toReturn;
  }
}

// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'domain-api.vendasta-local.com',
  'test': '',
  'demo': 'domain-demo.apigateway.co',
  'prod': 'domain-prod.apigateway.co',
  'production': 'domain-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let DomainApiService = /*#__PURE__*/(() => {
  class DomainApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getDnsRecords(r) {
      const request = r.toApiJson ? r : new GetDNSRecordsRequest(r);
      return this.http.post(this._host + "/domain.v1.DomainService/GetDNSRecords", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetDNSRecordsResponse.fromProto(resp)));
    }
    getIdentifierByDomain(r) {
      const request = r.toApiJson ? r : new GetIdentifierByDomainRequest(r);
      return this.http.post(this._host + "/domain.v1.DomainService/GetIdentifierByDomain", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetIdentifierByDomainResponse.fromProto(resp)));
    }
    getDomainByIdentifier(r) {
      const request = r.toApiJson ? r : new GetDomainByIdentifierRequest(r);
      return this.http.post(this._host + "/domain.v1.DomainService/GetDomainByIdentifier", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetDomainByIdentifierResponse.fromProto(resp)));
    }
    getSpfRecord(r) {
      const request = r.toApiJson ? r : new GetSPFRecordRequest(r);
      return this.http.post(this._host + "/domain.v1.DomainService/GetSPFRecord", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSPFRecordResponse.fromProto(resp)));
    }
    getDmarcRecord(r) {
      const request = r.toApiJson ? r : new GetDMARCRecordRequest(r);
      return this.http.post(this._host + "/domain.v1.DomainService/GetDMARCRecord", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetDMARCRecordResponse.fromProto(resp)));
    }
  }
  DomainApiService.ɵfac = function DomainApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DomainApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  DomainApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DomainApiService,
    factory: DomainApiService.ɵfac,
    providedIn: 'root'
  });
  return DomainApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DomainService = /*#__PURE__*/(() => {
  class DomainService {
    constructor(api) {
      this.api = api;
    }
    getDomainByIdentifier(contextualIdentifier) {
      return this.api.getDomainByIdentifier({
        identifier: {
          contextualIdentifier: contextualIdentifier
        }
      });
    }
    getSpfRecord(domain) {
      return this.api.getSpfRecord({
        primary: {
          domain: domain.domain,
          secure: domain.secure
        }
      }).pipe(map(resp => resp.record));
    }
    getDmarcRecord(domain) {
      return this.api.getDmarcRecord({
        primary: {
          domain: domain.domain,
          secure: domain.secure
        }
      }).pipe(map(resp => resp.record));
    }
  }
  DomainService.ɵfac = function DomainService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DomainService)(i0.ɵɵinject(DomainApiService));
  };
  DomainService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DomainService,
    factory: DomainService.ɵfac,
    providedIn: 'root'
  });
  return DomainService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DMARCRecord, DomainService, GetDomainByIdentifierResponse, SPFRecord };
